<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.approvals') }}</h5>
    </template>

    <b-alert v-if="item.approval_feedback" show variant="warning">
      <strong>{{ $t('sandoz.feedback') }}:</strong>
      {{ item.approval_feedback }}
    </b-alert>

    <h6>{{ $t('sandoz.circulation') }}</h6>
    <table class="table table-sm" v-if="approvers.length">
      <thead>
        <tr>
          <th>{{ $t('sandoz.role') }}</th>
          <th>{{ $t('sandoz.person') }}</th>
          <th>{{ $t('sandoz.date') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in approvers" :key="row.idx">
          <td>{{ row.role }}</td>
          <td>{{ row.person || '-' }}</td>
          <td>{{ row.date || '-' }}</td>
        </tr>
      </tbody>
    </table>
    <p v-else class="text-muted">{{ $t('sandoz.approvers_unassigned') }}</p>

    <hr/>

    <o-form-group :label="$t('sandoz.sales_rep_comment')">
      <b-form-textarea v-model="item.sales_rep_comment" rows="3" :disabled="readonly"/>
    </o-form-group>

    <o-form-group v-if="superUser" :label="$t('sandoz.super_user_comment')">
      <b-form-textarea v-model="item.super_user_comment" rows="3"/>
    </o-form-group>

    <o-checkbox v-if="item.plan_deviation_skip_approval !== undefined"
                :label="$t('sandoz.plan_deviation_skip_approval')"
                v-model="item.plan_deviation_skip_approval"/>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * Approver chain block. Renders the circulation table read-only — the approve/reject actions
 * live in the page-level save bar and call the same endpoints the legacy pages use
 * (ContractApprovalController). Sales rep + super user comment fields are editable.
 *
 * Source: kam/ContractDetail.vue (most complete approver UI).
 */
export default {
  name: 'SectionApprovals',
  mixins: [sectionMixin],
  computed: {
    superUser() {
      const user = this.dynamicContract && this.dynamicContract.$root && this.dynamicContract.$root.user
      return user ? !!user.is_super_user : false
    },
    approvers() {
      const rows = []
      for (let i = 1; i <= 6; i += 1) {
        const role = this.item[`approver_${i}`]
        if (!role) {
          continue
        }
        rows.push({
          idx: i,
          role,
          person: this.item[`approval_person_${i}`],
          date: this.item[`approval_date_${i}`]
        })
      }
      return rows
    }
  }
}
</script>
